import React, { Component, useState, useEffect, useRef } from 'react'
import useStateRef from 'react-usestateref';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Helper from '../Helper'
import { useSelector, useDispatch } from 'react-redux';
import { forgotPasswordMsgAction } from '../../middleware/forgotPasswordMsgAction';
export const CbForgotPassword = ({ containerObject, templateName, contentId, dataZone }) => {

    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage, errorMessageRef] = useStateRef("");
    const [url, setUrl, urlRef] = useStateRef("");
    const [currentPageUrl, setCurrentPageUrl, currentPageUrlRef] = useStateRef('');
    const dispatch = useDispatch();
    const history = useHistory()
    const errorDivRef = useRef(null);
    const profile = useSelector(state => state.getProfileDetails.profileDetails)
    useEffect(() => {
        // setCurrentPageUrl(window.location.pathname);
        // var url = history.location.pathname
        // var splitedUri = url.split("/")
        // splitedUri && splitedUri[1] && splitedUri[2] ? setCurrentPageUrl("/"+splitedUri[1] + "/" + splitedUri[2]) : "";
        // console.log('currentPageUrlRef',currentPageUrlRef.current);
        var searchParam = window.location.search
        const params = new URLSearchParams(searchParam);
        var resumeUrl = params.get('resume')
        setUrl(resumeUrl)
        // var userEmail = params.get('email')
        // setTimeout(() => {
        //     if(userEmail){
        //         var forgotEmail = document.getElementById("forgot_email");
        //         if(forgotEmail){
        //          forgotEmail.setAttribute("value",userEmail)
        //         }
        //      }
        // }, 1000);
        
    }, [])


    useEffect(() => {
        var url = history.location.pathname
        var splitedUri = url.split("/")
        splitedUri && splitedUri[1] && splitedUri[2] ? setCurrentPageUrl(splitedUri[1] + "/" + splitedUri[2]) : "";
        if (profile) {
            console.log('currentUrl...', currentPageUrlRef.current);
            if (profile && profile.userType && currentPageUrlRef?.current && currentPageUrlRef.current == "account/forgotPassword") {
                window.location.href = "/"
            }
        }
    }, [profile])

    const validateForgetPasswordForm = (key, value) => {
        setHasError(false)
        switch (key) {
            case "email":
                var result = Helper.isEmpty(value)
                var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("forgetPassword-message-error-div").classList.remove("d-none")
                    document.getElementById("forgetPassword-message-error-div").classList.add("d-block")
                    document.getElementById("forgot_email").classList.add("has-error")
                    var emptyErrorMessage = document.getElementById("forgot_error")
                    emptyErrorMessage.innerHTML = "Email Address is a required field.";
                    // if (errorDivRef.current) {
                    //     errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    // }
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("forgetPassword-message-error-div").classList.remove("d-none")
                    document.getElementById("forgetPassword-message-error-div").classList.add("d-block")
                    document.getElementById("forgot_email").classList.add("has-error")
                    var emptyErrorMessage = document.getElementById("forgot_error")
                    emptyErrorMessage.innerHTML = "The email address does not appear to be valid. Please use the format name@domain.xxx.";
                    // if (errorDivRef.current) {
                    //     errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    // }
                } else {
                    document.getElementById("forgetPassword-message-error-div").classList.remove("d-block")
                    document.getElementById("forgetPassword-message-error-div").classList.add("d-none")
                    document.getElementById("forgot_email").classList.remove("has-error")
                    var emptyFirstName = document.getElementById("forgot_error")
                    emptyFirstName.innerHTML = "";
                    // if (errorDivRef.current) {
                    //     errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    // }
                }
                break;

            default:
        }
    }

    const clearErrorMsg = (e) => {
        document.getElementById("forgot_error").innerHTML = "";
        document.getElementById("forgetPassword-message-error-div").classList.remove("d-block");
        document.getElementById("forgetPassword-message-error-div").classList.add("d-none");
        document.getElementById("forgot_email").classList.remove("has-error")
    }
    const goBack = () => {
        history.goBack();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        clearErrorMsg();
        //setShowCaptcha(false);
        //setIsLoading(false)
        var actionUrl = event.target.getAttribute('action');
        var formId = event.target.id;

        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());

        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateForgetPasswordForm(key, value)
        })
        console.log("setHasErrorRef.current", setHasErrorRef.current)
        if (!setHasErrorRef.current) {
            var email = formData.get("email")
            var successUrl = formData.get("successUrl")
            var errorUrl = formData.get("errorUrl")
            var resumePage = formData.get("resumePage")

            const inputMap = {
                email: email,
                successUrl: successUrl,
                errorUrl: errorUrl,
                resumePage: resumePage
            }
            //setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        var successMsg = res?.response;
                        if(successMsg){
                            dispatch(forgotPasswordMsgAction(successMsg));
                        }
                        const redirectUrl = res.response
                        if(currentPageUrlRef.current == "account/forgotPassword"){
                            history.push("/account/login?resetEmail=true&resume=prev",{successMsg:successMsg});
                        }else{
                            history.push("/checkout/login?resetEmail=true&resume=prev",{successMsg:successMsg});
                        }
                    } else {
                        //  setIsLoading(false)
                        const error = res._ERROR_MESSAGE_;
                        setErrorMessage(error);
                        document.getElementById("forgetPassword-message-error-div").classList.remove("d-none");
                        document.getElementById("forgetPassword-message-error-div").classList.add("d-block");
                        document.getElementById("forgot_email").classList.add("form-error");
                        // if (errorDivRef.current) {
                        //     errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        // }
                    }
                })
        }
    }

    return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
                {profile && profile.transient ?
                    <>
                        <div className='row justify-content-center gx-0'>
                            <div className="col-12 col-md-8 mt-md-4 mt-3 mx-lg-auto trpadding">
                                <div id="forgetPassword-message-success-div" className='d-none alert alert-success'>
                                    <div id="forgetPassword-message-success"></div>
                                </div>
                                <div id="forgetPassword-message-error-div" ref={errorDivRef} className='alert alert-danger d-none p-1' style={{ padding: "5px" }}>
                                    <div id="forgot_error" dangerouslySetInnerHTML={{ __html: errorMessageRef.current }}></div>
                                    {/* <div id="forgot_error"></div> */}
                                </div>
                            </div>
                        </div>

                        <div className='row justify-content-center gx-0'>
                            <div className="col-11 col-md-4 mb-md-5 mt-3 mt-md-0 trpadding">

                                <div className="text-left mb-2">
                                    <Link className="c-back-link text-left" to={currentPageUrlRef.current?.includes('checkout/forgotPassword') ? '/checkout/login' : urlRef.current ? `/account/login?resume=${urlRef.current}` : "/account/login"} >&lt;&nbsp;back to sign in</Link>
                                </div>
                                <div className="c-account-wrapper w-100">
                                    <div className="text-left mt-3 mb-3">
                                        <h1 className="c-account-heading">
                                            Reset Password
                                        </h1>
                                    </div>
                                    <div className="mb-3" >
                                        <p className="c-regular-text">
                                            Enter the email address associated with your account and we will email instructions on how to reset your password.
                                        </p>
                                    </div>
                                    <form method="post" action="forgot-password" id="forgot-password" className="row g-3 c-account-page" onSubmit={handleSubmit} noValidate>
                                        <div className="col-md-12">
                                            <label for="inputEmail4" className="form-label">Email</label>
                                            <input maxlength="256" name="email" id="forgot_email" type="email" className="form-control" />
                                        </div>
                                        <div className="col-12 d-grid mb-4">
                                            <button type="submit" className="btn btn-primary block" id="signin-button">Send Reset Instructions</button>
                                        </div>
                                        <input type="hidden" name="successUrl" id="successUrl" value={currentPageUrlRef.current == "account/forgotPassword" ? "/account/login.jsp?resetEmail=true" : "/checkout/login.jsp?resetEmail=true"} />
                                        <input type="hidden" name="errorUrl" id="errorUrl" value={currentPageUrlRef.current == "account/forgotPassword" ? "/account/forgotPassword.jsp" : "/checkout/forgotPassword.jsp"} />
                                        <input type="hidden" name="resumePage" id="resumePage" value="prev" />
                                    </form>
                                </div>

                            </div>
                        </div>

                    </> : <></>}
            </div>
        </>
    )
}
